export default __webpack_public_path__ + "static/media/bodyBG.15d24f19.jpg";